<template>
  <div>
    <!-- 编辑、添加界面 -->
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="1100px" :destroy-on-close="true"
      :before-close="cancel">
      <div class="el-dialog-div">
        <el-form class="formDiv" label-width="125px" ref="formRecord" :model="formRecord" :rules="rulesRecord">
          <el-form-item label="销售" prop="applicantId">
            <el-select style="width: 330px;" v-model="formRecord.applicantId" placeholder="请选择销售" filterable>
              <el-option v-for="item in applicantOptions" :key="item.uuid" :label="item.name"
                :value="item.uuid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请日期" prop="applicationDate">
            <el-input style="width: 330px;" size="small" v-model="formRecord.applicationDate" auto-complete="off"
              placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
          </el-form-item>
          <el-form-item label="合同编号" prop="contractIds">
           <el-select v-model="formRecord.contractIds" filterable multiple remote reserve-keyword
              :remote-method="remoteMethod" :disabled="contractRecord || selectType.type === 'edit'" placeholder="请输入合同编号"
              style="width: 330px;">
              <el-option v-for="item in contractOption" :key="item.id"
                :label="item.contractNumber + '-' + item.contractName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="试剂清单">
            <div style="display: flex;align-items: center">
              <el-input style="width: 70%!important;" v-model="recordFileName" readonly></el-input>
              <el-upload style="width: 17%!important;" class="upload-demo" action="" :auto-upload="false"
                :show-file-list="false" :on-change="(...event)=>{handleChange(event,'record')}"
                :file-list="recordFileList" :on-exceed="handleExceed">
                <el-button size="small" style="margin-left: 10px;" icon="el-icon-plus" type="primary"></el-button>
              </el-upload>
              <el-button type="danger" size="small" style="width: 13%!important;" icon="el-icon-delete"
                @click="handleRemove([],'record')"></el-button>
            </div>
          </el-form-item>
          <el-form-item label="可开票金额" prop="invoicedAmount">
            <el-input style="width: 330px;" size="small" v-model="invoicedAmount" auto-complete="off"
              disabled></el-input>
          </el-form-item>
          <div style="margin-left: 20px;margin-top:-15px;width: 50%">
            <span class="bold-text">备注：</span><br>
            <span class="bold-text">1.此处仅用于上传试剂清单。</span><br>
            <span class="bold-text">2.如果需要把单价数量单位规格开到发票里,请在发票备注里写清楚。</span><br>
            <span class="bold-text">3.多个合同合并开票时，剩余可开票金额需全部开完。</span>
          </div>
          <div style="width: 100%">
            <div style="display: flex;align-items: center" v-for="(invoiceInfo, index) in formRecord.invoiceInfos">
              <div style="display: flex;flex-wrap:wrap;position: relative;width: 98%;" class="invoice-box">
                <!-- 右上角关闭按钮 -->
                <el-button type="text" icon="el-icon-close" class="invoice-close-btn" @click="handleDelete(invoiceInfo)"
                  circle size="small" title="移除本发票"></el-button>
                <el-form-item label="发票金额" :prop="'invoiceInfos.'+index+'.invoiceAmount'" style="width: 33%!important;"
                  label-width="90px"
                  :rules="[{required: true, message: '请输入发票金额', trigger: 'change'},{ validator: checkNum, trigger: 'change' }]">
                  <el-input size="small" v-model="invoiceInfo.invoiceAmount" auto-complete="off"
                    placeholder="请输入发票金额"></el-input>
                </el-form-item>
                <el-form-item label="发票类型" :prop="'invoiceInfos.'+index+'.invoiceType'" style="width: 33%!important;"
                  label-width="90px" :rules="{required: true, message: '请选择发票类型', trigger: 'change'}">
                  <el-select v-model="invoiceInfo.invoiceType" placeholder="请选择发票类型" filterable>
                    <el-option v-for="item in TypeOptions" :key="item.label" :label="item.label"
                      :value="item.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="纳税人识别号" style="width: 33%!important;" label-width="100px">
                  <el-input size="small" v-model="invoiceInfo.taxRegistrationNumber" disabled></el-input>
                </el-form-item>
                <el-form-item label="开票公司" label-width="90px" :prop="'invoiceInfos.'+index+'.billingUnitId'"
                  style="width: 50%!important;" :rules="{required: true, message: '请选择开票公司', trigger: 'change'}">
                  <el-select v-model="invoiceInfo.billingUnitId" placeholder="请选择开票公司" filterable>
                    <el-option v-for="item in businessOption" :key="item.id" :label="item.companyName" :value="item.id"
                      :disabled="!item['companyInvoiceStatus']"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="发票抬头" style="width: 49%!important;" label-width="90px"
                  :prop="'invoiceInfos.'+index+'.invoiceTitleId'"
                  :rules="{required: true, message: '请选择发票抬头', trigger: 'change'}">
                  <el-select v-model="invoiceInfo.invoiceTitleId" filterable placeholder="请选择发票抬头"
                    @change="(value) => selectTitle(invoiceInfo,value)">
                    <el-option v-for="item in companyOption" :key="item.id" :label="item.companyName"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="发票内容" style="width: 99%!important;" label-width="90px"
                  :prop="'invoiceInfos.' + index + '.invoiceContent'"
                  :rules="{ required: true, message: '请输入发票内容', trigger: 'change' }">
                  <el-input type="textarea" v-model="invoiceInfo.invoiceContent" :autosize="{ minRows: 3 }"
                    show-word-limit maxlength="300" auto-complete="off"
                    placeholder="请输入发票内容，例如:测序费 测试费 测序分析费"></el-input>
                </el-form-item>
                <el-form-item label="发票备注" :prop="'invoiceInfos.'+index+'.remark'" label-width="90px"
                  style="width: 99%!important;">
                  <el-input type="textarea" v-model="invoiceInfo.remark" auto-complete="off" :autosize="{ minRows: 3}"
                    show-word-limit maxlength="300" placeholder="注：如果需要把单价数量单位规格开到发票里,请在发票备注里写清楚。"></el-input>
                </el-form-item>
              </div>
             <div style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
                <el-button type="danger" size="mini" icon="el-icon-delete" @click="handleDelete(invoiceInfo)"
                  style="margin-bottom: 2px;"></el-button>
                <el-button size="mini" icon="el-icon-plus" type="success" style="margin: 1px 0 0;"
                  v-if="index === formRecord.invoiceInfos.length - 1" @click="handleAdd"></el-button>
              </div>
            </div>
          </div>
          <div v-if="formRecord.invoiceInfos.length > 1" style="display: flex;flex-wrap: wrap;width: 100%;">
            <el-form-item label="是否可连号" prop="connectedFlag">
              <el-select style="width: 87%;" v-model="formRecord.connectedFlag" placeholder="请选择是否可连号" filterable>
                <el-option v-for="item in SFOptions" :key="item.label" :label="item.name"
                  :value="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否同一天" prop="sameDayFlag">
              <el-select style="width: 87%;" v-model="formRecord.sameDayFlag" placeholder="请选择是否同一天" filterable>
                <el-option v-for="item in SFOptions" :key="item.label" :label="item.name"
                  :value="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="formRecord.sameDayFlag === 0" label="开票日期备注" prop="remark"
              style="width: 92%!important;">
              <el-input type="textarea" v-model="formRecord.remark" auto-complete="off" :autosize="{ minRows: 3 }"
                show-word-limit maxlength="300"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div v-if="selectType?.type === 'add'">
          <div style="width: 100%!important;">
            <span class="bold-text">注：如需邮寄，请点击下方开关"添加邮寄/扫描信息"。</span>
          </div>
          <el-divider></el-divider>
          <el-switch v-model="isMail" active-text="添加邮寄/扫描信息"></el-switch>
          <br><br>
          <el-form class="formDiv" v-if="isMail" label-width="120px" ref="formMail" :model="formMail"
            :rules="rulesMail">
            <div style="width: 100%;margin-bottom: 20px;text-align: center">
              <el-table :fit="false" style="width: 917px;display: inline-block" border :data="tableData">
                <el-table-column label="邮寄说明" width="90" prop="name"></el-table-column>
                <el-table-column label="是否邮寄" width="88" align="center">
                  <template slot-scope="scope">
                    <el-form-item label-width="0" :prop="'mailingContent.' + scope.row.mailProp"
                      v-if="scope.row.mailProp" style="width: 100%!important;margin-bottom: 0"
                      :rules="{required: true, message: scope.row.mailMessage, trigger: 'change'}">
                      <el-select style="width: 100%" v-model="formMail.mailingContent[scope.row.mailProp]"
                        @change="(value) => changeMailNumber(value,scope.row.type)" class="no-border-select"
                        :placeholder=scope.row.mailMessage>
                        <el-option v-for="item in numberOption.slice(scope.row.min,scope.row.max)" :key="item.value"
                          :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                    <span v-else>{{'NA'}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="是否扫描" width="88" align="center">
                  <template slot-scope="scope">
                    <el-form-item label-width="0" :prop="'mailingContent.' + scope.row.scanningProp"
                      v-if="scope.row.scanningProp" style="width: 100%!important;margin-bottom: 0"
                      :rules="{required: true, message: scope.row.scanningMessage, trigger: 'change'}">
                      <el-select style="width: 100%" v-model="formMail.mailingContent[scope.row.scanningProp]"
                        @change="(value) => changeMailNumber(value,scope.row.type)" class="no-border-select"
                        :placeholder=scope.row.scanningMessage>
                        <el-option v-for="item in flagOption" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                    <span v-else>{{'NA'}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="上传文件" width="350" align="center">
                  <template slot-scope="scope">
                    <el-form-item style="width: 100%!important;margin-bottom: 0" label-width="0" v-if="scope.row.file">
                      <div style="display: flex; align-items: center; width: 100%;">
                        <div style="width: 86%!important;">
                          <div style="width: 100%!important;margin-bottom: 2px;"
                            v-if="$data[scope.row.fileList].length > 0"
                            v-for="(fileItem, fileIndex) in $data[scope.row.fileList]">
                            <div style="display: flex;width: 100%!important;">
                              <el-input v-model="fileItem.name" readonly style="margin-right: 5px;"></el-input>
                              <div>
                                <el-button type="danger" icon="el-icon-delete" size="small"
                                  @click="handleRemove([fileIndex], scope.row.type)"></el-button>
                              </div>
                            </div>
                          </div>
                          <div v-if="$data[scope.row.fileList].length <= 0"
                            style="display: flex;width: 100%!important;">
                            <el-input v-if="$data[scope.row.fileList].length <= 0" v-model="$data[scope.row.fileName]"
                              style="margin-right: 5px;" readonly></el-input>
                            <div>
                              <el-button type="danger" icon="el-icon-delete" size="small"></el-button>
                            </div>
                          </div>
                        </div>

                        <el-upload class="upload-demo" action="" :auto-upload="false" :show-file-list="false"
                          :on-change="(...event) => { handleChange(event, scope.row.type) }" :multiple="true"
                          style="width: 5%!important;margin-left: 5px" :file-list="$data[scope.row.fileList]"
                          :on-exceed="handleExceed">
                          <el-button type="primary" icon="el-icon-plus" size="small"></el-button>
                        </el-upload>

                      </div>
                    </el-form-item>
                    <span v-else>{{'NA'}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="备注" width="300" align="center">
                  <template slot-scope="scope">
                    <el-form-item label-width="0" style="width: 100%!important;margin-bottom: 0"
                      :prop="'mailingContent.' + scope.row.remark" v-if="scope.row.remark">
                      <el-input v-model="formMail.mailingContent[scope.row.remark]" auto-complete="off"
                        class="no-border-select" type="textarea" :autosize="{ minRows: 1}" show-word-limit
                        maxlength="300" :placeholder=scope.row.remarkMessage style="width: 100%;"></el-input>
                    </el-form-item>
                    <span v-else>{{'NA'}}</span>
                  </template>
                </el-table-column>
              </el-table>
              <div style="text-align: left;margin-left: 6%"><span
                  class="bold-text">{{'备注:1.客户需要报账合同等及其他报账资料需要单独在邮寄/扫描模块内选择"报账资料"上传附件'}}</span>
                <el-tooltip content="折叠" v-if="showRemark">
                  <i class="el-icon-caret-top iconMore" @click="showRemark = !showRemark"></i>
                </el-tooltip>
                <el-tooltip content="展开" v-if="!showRemark">
                  <i class="el-icon-caret-bottom iconMore" @click="showRemark = !showRemark"></i>
                </el-tooltip><br>
                <span class="bold-text"
                  v-if="showRemark">{{'2.需要注意的是报账合同尽量用实际项目的合同，如果不一致，合同要合法并符合公司规定(公司涉及到的正常项目及公司正常报价范围)'}}</span><br>
                <span class="bold-text"
                  v-if="showRemark">{{'3.尽量不要开试剂票，开了的，公司不提供任何图片和实物。没有按照以上操作的，后果销售自己承担。'}}</span><br>
                <span class="bold-text" v-if="showRemark">{{'4.上传文件可上传多个文件，最大上传数量不能超过5,上传文件总大小不能超过50M。'}}</span>
              </div>
            </div>
            <el-form-item label="销售" prop="applicantId">
              <el-select style="width: 350px;" v-model="formMail.applicantId" placeholder="请选择销售" filterable>
                <el-option v-for="item in applicantOptions" :key="item.uuid" :label="item.name"
                  :value="item.uuid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申请日期" prop="applicantDate" label-width="147px">
              <el-input style="width: 350px;" size="small" v-model="formMail.applicantDate" auto-complete="off"
                placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
            </el-form-item>
            <el-form-item label="收件人:" prop="recipientName"
              :rules="{required: flag, message: '请输入收件人名称', trigger: 'change'}">
              <el-autocomplete class="inline-input" v-model="formMail.recipientName" :fetch-suggestions="querySearch"
                placeholder="请输入收件人名称" @select="handleSelect" style="width: 330px;">
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="收件人电话" prop="recipientPhone" label-width="147px"
              :rules="{required: flag, message: '请输入收件人电话', trigger: 'change'}">
              <el-input style="width: 330px;" v-model="formMail.recipientPhone" placeholder="请输入收件人电话"></el-input>
            </el-form-item>
            <el-form-item label="收件地址" prop="recipientAddress"
              :rules="{required: flag, message: '请输入收件人地址', trigger: 'change'}">
              <el-input style="width: 330px;" v-model="formMail.recipientAddress" placeholder="请输入收件地址"></el-input>
            </el-form-item>
            <el-form-item label="邮寄备注:" prop="remark" v-if="isMail" style="width: 98%!important;">
              <el-input :autosize="{ minRows: 3}" type="textarea" maxlength="300" show-word-limit style="width: 810px"
                placeholder="请输入内容" v-model="formMail.remark">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handleSubmit">提交</el-button>
      </div>
    </el-dialog>
    <loading :loading="loading || dataLoading" :load-text="dataLoading ?  '数据加载中' : '提交中'"></loading>
  </div>
</template>

<script>
import {getPersonById, getPersonByType} from "@/api/dilivery/customer/person";
import {addContractRecordMail, getAllContract} from "@/api/dilivery/sales/contract";
import {getCompanyPage} from "@/api/dilivery/company";
import {getAllCompanyName} from "@/api/dilivery/customer/company";
import {getDataInLocalStorage} from "@/utils/localStorage";
import { checkDate, checkNum} from "@/utils/rules";
import {padDate} from "@/store/date";
import {getUserById} from "@/api/dilivery/customer/user";
import { downloadRecord, editRecord} from "@/api/dilivery/record";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "AddRecordMail",
  props:['showDialog','contractDetail','selectType','selectDetail'],
  components: { Loading },
  data(){
    return{
      dataLoading:false,
      showRemark:true,
      tableData: [
        {
          id: 1,
          name: '合同',
          mailProp: 'numberOfContract',
          mailMessage: '请选择合同邮寄份数',
          type: 'contract',
          min: 0,
          max: 11,
          scanningProp: 'contractScanningFlag',
          scanningMessage: '请选择是否扫描合同',
          file: '',
          fileName: '',
          fileList: '',
          remark: 'contractExplain',
          remarkMessage: '请填写合同具体邮寄说明'
        },
        // {
        //   id: 2,
        //   name: '发票',
        //   mailProp: 'numberOfInvoice',
        //   mailMessage: '请选择发票邮寄份数',
        //   type: 'invoice',
        //   min: 0,
        //   max: 11,
        //   scanningProp: '',
        //   scanningMessage: '',
        //   file: '',
        //   fileName: '',
        //   fileList: '',
        //   remark: 'invoiceExplain',
        //   remarkMessage: '请填写发票具体邮寄说明'
        // },
        {
          id: 3,
          name: '营业执照',
          mailProp: 'numberOfLicense',
          mailMessage: '请选择营业执照邮寄份数',
          type: 'license',
          min: 0,
          max: 4,
          scanningProp: '',
          scanningMessage: '',
          file: '',
          fileName: '',
          fileList: '',
          remark: 'licenseExplain',
          remarkMessage: '请填写营业执照具体邮寄说明'
        },
        {
          id: 4,
          name: '结题报告',
          mailProp: 'numberOfReport',
          mailMessage: '请选择结题报告邮寄份数',
          type: 'report',
          min: 0,
          max: 6,
          scanningProp: 'reportScanningFlag',
          scanningMessage: '请选择是否扫描结题报告',
          file: 'reportFile',
          fileName: 'reportFileName',
          fileList: 'reportFileList',
          remark: 'reportExplain',
          remarkMessage: '请填写结题报告具体邮寄说明'
        },
        {
          id: 5,
          name: '报账资料',
          mailProp: 'numberOfReimbursementFile',
          mailMessage: '请选择邮寄报账资料份数',
          type: 'reimbursement',
          min: 0,
          max: 6,
          scanningProp: 'reimbursementScanningFlag',
          scanningMessage: '请选择是否扫描报账资料',
          file: 'reimbursementFile',
          fileName: 'reimbursementFileName',
          fileList: 'reimbursementFileList',
          remark: 'reimbursementExplain',
          remarkMessage: '请填写报账资料具体邮寄说明'
        },
      ],
      role:'',
      numberOption: [
        {label: '否', value: 0},
        {label: '1份', value: 1},
        {label: '2份', value: 2},
        {label: '3份', value: 3},
        {label: '4份', value: 4},
        {label: '5份', value: 5},
        {label: '6份', value: 6},
        {label: '7份', value: 7},
        {label: '8份', value: 8},
        {label: '9份', value: 9},
        {label: '10份', value: 10}
      ],
      flagOption: [
        {label:'是',value:true},
        {label:'否',value:false},
      ],
      loading:false,
      reimbursementFileName: '',
      reimbursementFileList: [],
      isMail:false,
      mailFileName: '',
      reportFileName:'',
      contractRecord:false,
      userData:{},
      title:'',
      fileList: [],
      reportFileList:[],
      applicantOptions: [],
      contractOption: [],
      businessOption: [],
      companyOption: [],
      ContactOptions: [],
      TypeOptions: [
        {label: '全电普票'},
        {label: '全电专票'},
      ],
      SFOptions: [
        {label: 1, name: '是'},
        {label: 0, name: '否'}
      ],
      formMail:{
        reportFile:[],
        reimbursementFile:[],
        invoiceId: [],
        contractId: [],
        mailingContent: {
          contractExplain: '',
          invoiceExplain: '',
          reportExplain: '',
          licenseExplain: '',
          contractScanningFlag: false,
          reportScanningFlag: false,
          reimbursementScanningFlag: false,
          numberOfContract: 0,//邮寄合同数量
          numberOfInvoice: 0,//邮寄发票数量
          numberOfReport: 0,//邮寄报告数量
          numberOfLicense: 0,//营业执照数量
          numberOfReimbursementFile: 0,//报账资料份数
          numberOfSingleMailFile: 0,
          reimbursementExplain: '',//报账资料说明
          singleMailFileExplain: ''//单独邮寄文件说明
        },
        appendixExist: true,
        status:'APPLYING',
        mailAttachment: [],
        applicantId: '',
        applicantDate: '',
        recipientAddress: '',
        recipientPhone: '',
        recipientName: '',
        remark: ''
      },
      recordFileList: [],
      recordFileName: '',
      formRecord: {
        remark: '',
        invoiceRecordFile: null,
        invoiceInfos: [],
        taxRegistrationNumber: '',
        bankAccountNumber: '',
        billingAddressPhone: '',
        invoiceIds: [],
        status: 'APPLYING',
        applicantId: '',
        contractIds:[],
        applicationDate: '',
        connectedFlag: '',
        sameDayFlag: '',
      },
      rulesRecord: {
        applicantId: [
          {required: true, message: '请选择销售', trigger: 'change'}
        ],
        contractIds: [
          {required: true, message: '请选择合同', trigger: 'change'}
        ],
        applicationDate: [
          {required: true, message: '请选择申请日期', trigger: 'change'},
          {validator: checkDate, trigger: 'change'}
        ],
        connectedFlag: [
          {required: true, message: '请选择是否可连号', trigger: 'change'}
        ],
        sameDayFlag: [
          {required: true, message: '请选择是否同一天', trigger: 'change'}
        ],
        remark: [
          { required: true, message: '请填写开票日期备注', trigger: 'change' }
        ]
      },
      rulesMail: {
        applicantId: [
          {required: true, message: '请选择销售', trigger: 'change'}
        ],
        applicantDate: [
          {required: true, message: '请选择申请日期', trigger: 'change'},
          {validator: checkDate, trigger: 'change'}
        ],
      },
    }
  },
  computed: {
    flag(){
      const choseFlag = ['numberOfContract','numberOfInvoice','numberOfReport','numberOfLicense','numberOfReimbursementFile']
      for(const key of choseFlag){
        if(this.formMail.mailingContent[key]){
          return true
        }
      }
      return !(this.formMail.mailingContent.contractScanningFlag || this.formMail.mailingContent.reportScanningFlag || this.formMail.mailingContent.reimbursementScanningFlag);
    },
    invoicedAmount() {
      return this.formRecord.contractIds.map(itemA => {
        const foundItem = this.contractOption.find(itemB => itemA === itemB.id);
        return foundItem ? foundItem.invoicedAmount : null;
      }).filter(invoicedAmount => invoicedAmount !== null).map(amount => Number(amount)).reduce((sum, amount) => sum + amount, 0);
    },
    contractFirst() {
      if (this.formRecord.contractIds.length > 0) {
        const contract = this.contractOption.find(item => this.formRecord.contractIds[0] === item.id)
        console.log(contract);
        
        if (contract) {
          return contract
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
  },
  watch: {
    selectType:{
      handler(newVal){
        if (newVal?.type){
          if(newVal.type==='edit'){
            this.title='编辑发票信息'
          }else{
            this.title='添加发票信息'
          }
        }
      },
      immediate:true
    },
    invoicedAmount: {
      handler(newVal,oldVal){
        if(newVal){
          if(Number(this.formRecord.invoiceInfos[0].invoiceAmount) === 0 || Number(this.formRecord.invoiceInfos[0].invoiceAmount) === Number(oldVal)){
            this.formRecord.invoiceInfos[0].invoiceAmount = newVal
          }
        }
      },
      immediate:true
    },
    contractDetail: {
      handler(newVal) {
        if (newVal?.length > 0) {
          this.formRecord.contractIds = newVal.map(item => item.id)
          this.formRecord.applicantId = newVal.map(item => item.salesId)[0]
          if(this.contractOption.length<=0){
            this.contractOption = newVal.map(item => {
              return {
                ...item,
                customerCompanyId:item.customerContacts.companyId,
                taxRegistrationNumber:item.customerContacts.taxRegistrationNumber
              }
            })
          }
          this.contractRecord = true
        }
      },
      immediate: true
    },
    'formRecord.contractIds':{
      handler(newVal) {
        if (newVal) {
          this.formMail.contractId = newVal
        }
      },
      immediate: true,
    },
    'formRecord.applicantId': {
      handler(newVal) {
        if (newVal) {
          this.formMail.applicantId = newVal
        }
      },
      immediate: true,
    },
    'formRecord.applicationDate': {
      handler(newVal) {
        if (newVal) {
          this.formMail.applicantDate = newVal
        }
      },
      immediate: true,
    },
    contractFirst: {
      handler(newVal) {
        if(newVal){
          this.formRecord.invoiceInfos = this.formRecord.invoiceInfos.map(item => {
            return {
              ...item,
              billingUnitId: item.billingUnitId?item.billingUnitId:newVal.trusteeCompanyId,
              invoiceTitleId: item.invoiceTitleId?item.invoiceTitleId:newVal.customerCompanyId,
              taxRegistrationNumber:item.taxRegistrationNumber?item.taxRegistrationNumber:newVal.taxRegistrationNumber,
            }
          })
        }
      },
      immediate: true
    },
    isMail:{
      handler(newVal){
        if (newVal){
          this.title = '添加发票及邮寄信息'
        } else {
          if(this.selectType.type === 'add'){
            this.title = '添加发票信息'
          }else{
            this.title= '编辑发票信息'
          }
        }
      },
      immediate: true,
    },
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal).length > 0){
          const form = JSON.parse(JSON.stringify(this.formRecord))
          const newInfo = JSON.parse(JSON.stringify(newVal))
          this.formRecord = {
            ...form,
            ...newInfo,
            status: 'APPLYING',
            invoiceInfos: newVal.invoiceInfoDTOS
          }
          this.formRecord.id = newVal.id
          if(newVal.id && newVal['annex']){
            this.addFileManually(newVal.id)
          }
        }
      },
      immediate:true
    },
    'formMail.applicantId': {
      handler(newVal) {
        if (newVal !== '') {
          this.getContactOptions(newVal)
        } else {
          this.ContactOptions = []
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.remoteMethod();
    this.getBusinessOption();
    this.getApplicantOption();
    if (this.formRecord.applicationDate === '') {
      this.formRecord.applicationDate = this.getCurrentDate()
    }
    this.getCompanyOption()
    if(this.formRecord.invoiceInfos.length<=0){
      this.handleAdd()
    }
  },
  created() {
    this.userData = JSON.parse(getDataInLocalStorage('user'))
    this.role = getDataInLocalStorage('role')
  },
  methods: {
    async addFileManually(id) {
      try {
        const response = await downloadRecord(id);
        const file = new File([response.file], decodeURI(response.fileName), {type: response.file.type});
        // 创建一个文件对象的包装对象
        const fileWrapper = {
          name: file.name,
          status: 'ready',
          url: '',  // 如果需要，可以设置文件的URL
          raw: file,  // 实际的文件对象
        };
        this.formRecord.invoiceRecordFile = fileWrapper
        this.recordFileList.push(fileWrapper)
        this.recordFileName = file.name
      } catch (error) {
        console.log(error);
      }
    },
    selectTitle(invoiceInfo,value){
      const index = this.formRecord.invoiceInfos.indexOf(invoiceInfo)
      this.formRecord.invoiceInfos[index].taxRegistrationNumber = this.companyOption.find(item => item.id === value)?.taxRegistrationNumber
    },
    querySearch(queryString, cb) {
      const results = queryString ? this.ContactOptions.filter(item => item.contactName.toLowerCase().includes(queryString.toLowerCase())) : this.ContactOptions;
      const modifiedItems = results.map(item => {
        if (item.contactName) {
          return {
            ...item,
            value: item.contactName,
            contactName: undefined
          };
        }
        return item;
      });
      cb(modifiedItems);
    },
    handleSelect(item) {
      this.formMail.recipientPhone = item.phone
      this.formMail.recipientAddress = item.address
    },
    getContactOptions(uuid) {
      try {
        getUserById(uuid).then(res => {
          if (res.code === 200) {
            this.ContactOptions = res.data
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    handleExceed(files) {
      this.$messageUi.error('只能上传一个文件，请先移除已有文件再上传'); // 超出数量时提醒
    },
    changeMailNumber(value,type) {
      switch (type) {
        case 'report':
          if(this.formMail.reportFile.length<=0 && value){
            if(value === true){
              this.$messageUi.error('未上传结题报告，不能选择扫描结题报告')
              this.formMail.mailingContent.reportScanningFlag = false
            }else{
              this.$messageUi.error('未上传结题报告，不能选择邮寄')
              this.formMail.mailingContent.numberOfReport = 0
            }
          }
          break;
        case 'reimbursement':
          if (this.formMail.reimbursementFile.length<=0 && value) {
            if(value === true){
              this.$messageUi.error('未上传报账资料，不能选择扫描报账资料')
              this.formMail.mailingContent.reimbursementScanningFlag = false
            }else{
              this.$messageUi.error('未上传报账资料，不能选择邮寄')
              this.formMail.mailingContent.numberOfReimbursementFile = 0
            }
          }
          break;
        case 'mail':
          if (this.formMail.mailAttachment.length<=0 && value) {
            this.$messageUi.error('未上传单独邮寄附件，不能选择邮寄')
            this.formMail.mailingContent.numberOfSingleMailFile = 0
          }
          break;
        default:
          break;
      }
    },
    handleChange(files,type) {
      switch (type) {
        case 'record':
          this.formRecord.invoiceRecordFile = files[0];
          this.recordFileList = [files[0]]
          this.recordFileName = files[0].name
          break
        case 'report':
          this.formMail.reportFile = files[1].map(item => item)
          this.reportFileList = files[1].map(item => item)
          if(this.form.mailingContent.numberOfReport === 0){
            this.form.mailingContent.numberOfReport = 1
          }
          break
        case 'reimbursement':
          this.formMail.reimbursementFile = files[1].map(item => item)
          this.reimbursementFileList = files[1].map(item => item)
          if(this.form.mailingContent.numberOfReimbursementFile === 0){
            this.form.mailingContent.numberOfReimbursementFile = 1
          }
          break
        default:
          break
      }
    },
    handleRemove(files, type) {
      switch (type) {
        case 'record':
          this.formRecord.invoiceRecordFile = null;
          this.recordFileList = []
          this.recordFileName = ''
          break
        case 'report':
          this.formMail.reportFile.splice(files, 1)
          this.reportFileList.splice(files, 1)
          this.reportFileName = ''
          if(this.reportFileList.length<=0){
            this.formMail.mailingContent.numberOfReport = 0
            this.formMail.mailingContent.reportScanningFlag = false
          }
          break
        case 'reimbursement':
          this.formMail.reimbursementFile.splice(files, 1)
          this.reimbursementFileList.splice(files, 1)
          this.reimbursementFileName = ''
          if(this.reimbursementFileList.length<=0){
            this.formMail.mailingContent.numberOfReimbursementFile = 0
            this.formMail.mailingContent.reimbursementScanningFlag = false
          }
          break
        default:
          break
      }
    },
    getCompanyOption(){
      getAllCompanyName().then(res=>{
        if(res.code===200){
          this.companyOption = res.data
        }
      }).catch(err=>{})
    },
    checkNum,
    handleDelete(item) {
      const index = this.formRecord.invoiceInfos.indexOf(item)
      if (index !== -1) {
        if (this.formRecord.invoiceInfos[index].id) {
          this.formRecord.invoiceIds.push(this.formRecord.invoiceInfos[index].id)
        }
        this.formRecord.invoiceInfos.splice(index, 1)
      }
      if(this.formRecord.invoiceInfos.length<=0 || !Array.isArray(this.formRecord.invoiceInfos)){
        this.handleAdd()
      }
    },
    handleAdd() {
      const companyId = this.contractFirst?.trusteeCompanyId
      const companyTitleId = this.contractFirst?.customerCompanyId
      const taxRegistrationNumber = this.contractFirst?.taxRegistrationNumber
      let invoice = {
        billingUnitId: '1',//开票单位
        invoiceTitleId:'',
        invoiceAmount: 0,
        invoiceType: '',
        invoiceContent: '',
        remark: '',
      }
      if(companyId){
        invoice.billingUnitId = companyId
      }
      if(companyTitleId){
        invoice.invoiceTitleId = companyTitleId
      }
      if(taxRegistrationNumber){
        invoice.taxRegistrationNumber = taxRegistrationNumber
      }
      this.formRecord.invoiceInfos.push(invoice)
    },
    checkUser() {
      if (this.applicantOptions.some(item => item.uuid === this.userData['personUuids'][0])) {
        if (this.formRecord.applicantId === '') {
          this.formRecord.applicantId = this.userData['personUuids'][0]
        }
      }
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始, September == 8
      const day = date.getDate().toString().padStart(2, '0'); // 日期
      return `${year}-${month}-${day}`
    },
    remoteMethod(query) {
      try {
        if (this.contractDetail?.length > 0) {
          return
        }
        this.contractOption = [];
        this.contractLoading = true;
        let data = {}
        if (this.selectDetail && Object.keys(this.selectDetail)) {
          data["query#id.IN"] = this.selectDetail?.contractIds.join(',')
        }
        if (query) {
          data["query#contractNumber.LIKE"] = query
        }
        const sale = [...new Set(this.contractOption.filter(item => this.form.contractId.includes(item.id)).map(item => { return { salesId: item.salesId, customerContactsId: item.customerContactsId } }))]
        if (sale.length !== 0) {
          data["query#salesId.IN"] = sale.map(item => item.salesId).join(',')
          data["query#customerContactsId.IN"] = sale.map(item => item.customerContactsId).join(',')
        }
        getAllContract('INVOICED_CONTRACT', data).then(res => {
          if (res.code === 200) {
            this.contractLoading = false;
            this.contractOption = res.data
          }
        })
      } catch (error) {
        console.log(error);
        this.contractOption = [];
        this.contractLoading = false;
      }
    },
    getBusinessOption() {
      try {
        let params = {
          'page.current':1,
          'page.size':500,
          'order': 'id.asc'
        }
        getCompanyPage(params, {}).then(res => {
          if(res.code === 200){
            this.businessOption = res.data.records.filter(item => item['companyInvoiceStatus'])
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    getApplicantOption() {
      try {
        if(['ADMIN', 'MANAGER','SALES_ASSI_MANAGER','SALES_ASSI'].includes(this.role)){
          getPersonByType('SALES', {}).then(res => {
            if (res.code === 200){
              this.applicantOptions = res.data;
              this.checkUser();
            }
          })
        }else {
          getPersonById(this.userData['personUuids'][0], {}).then(res => {
            if (res.code === 200){
              this.applicantOptions = res.data;
              this.checkUser();
            }
          })
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancel() {
      this.$emit('submit', 'cancel')
    },
    validateForm(ref) {
      return new Promise((resolve) => {
        this.$refs[ref].validate((valid) => {
          resolve(valid);
        });
      });
    },
    async handleSubmit() {
      try {
        if (this.formRecord.invoiceInfos.length <= 0) {
          this.$messageUi.error('请申请至少一张发票')
          return
        }
        const [recordFormValid, mailFormValid] = await Promise.all([
          this.validateForm('formRecord'),
          this.isMail?this.validateForm('formMail'):true
        ]);

        if (recordFormValid && mailFormValid) {
          const invoiceAmounts = this.formRecord.invoiceInfos.map(item => {
            const amount = Number(item.invoiceAmount); // 将可能的字符串形式转换为数字
            return amount > 0 ? amount : 0; // 如果为大于0的数字，返回自身，否则返回0
          }).reduce((sum, amount) => sum + amount, 0);
          this.formRecord.applicationDate = padDate(this.formRecord.applicationDate)
          this.formMail.applicantDate = padDate(this.formMail.applicantDate)
          if(this.formRecord.contractIds.length>1){
            if (invoiceAmounts !== this.invoicedAmount) {
              this.$messageUi.error('合同合并开票总开票金额与总可开票金额不一致,请检查')
              return
            }
          }else{
            if (invoiceAmounts > this.invoicedAmount) {
              this.$messageUi.error('开票金额超出可开票金额' + Math.abs(invoiceAmounts - this.invoicedAmount) + ',请检查')
              return
            }
          }
          this.loading = true
          const formData = new FormData();
          if (this.formRecord.invoiceRecordFile) {
            formData.append('invoiceRecordFile', this.formRecord.invoiceRecordFile.raw); // 文件
          }
          const jsonStr2 = JSON.stringify(Object.keys(this.formRecord).reduce((acc, key) => {
            if (!['invoiceRecordFile'].includes(key)) {
              acc[key] = this.formRecord[key];
            }
            return acc;
          }, {}));
          const blob2 = new Blob([jsonStr2], {
            type: 'application/json'
          });
          if(this.selectType.type === 'add'){
            formData.append("invoiceInfo", blob2);
          }else{
            formData.append("info", blob2);
          }
          if (this.isMail && this.selectType.type === 'add') {
            if (this.formMail.reportFile.length>0) {
              for (let file of this.formMail.reportFile) {
                formData.append('reportFile', file.raw);
              }
            }
            if (this.formMail.reimbursementFile.length>0) {
              for (let file of this.formMail.reimbursementFile) {
                formData.append('reimbursementFile', file.raw);
              }
            }
            const jsonStr1 = JSON.stringify(
                Object.keys(this.formMail).reduce((acc, key) => {
                  if (!['mailAttachment', 'reportFile','reimbursementFile'].includes(key)) {
                    acc[key] = this.formMail[key];
                  }
                  return acc;
                }, {})
            );
            const blob1 = new Blob([jsonStr1], {
              type: 'application/json'
            });
            formData.append("mailInfo", blob1);
          }

          const ApiMethod = this.selectType.type === 'add'?addContractRecordMail:editRecord
          const response = await ApiMethod(formData)

          this.loading = false
          
          if(response.code === 200){
            if(this.selectType.type === 'add'){
              this.$messageUi.success(this.isMail?'发票及邮寄信息提交成功':'发票信息提交成功')
            }else{
              this.$messageUi.success('修改成功')
            }
            this.$store.commit('right/setChangeRed',true)
            this.$emit('submit','confirm')
          }
        } else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      } catch (error) { 
        console.log(error);
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.invoice-close-btn {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 2;
  color: #75787e;
  /* 普通灰色 */
  background: transparent;
  transition: color 0.2s;
}

.invoice-close-btn:hover {
  color: #409eff;
  /* 悬浮蓝色 */
  background: transparent;
}


.formDiv {
  display: flex;
  flex-wrap: wrap;
}

.el-form-item {
  width: 45% !important;
}
.upload-demo {

  /*margin-top: 20px;*/
  width: 100% !important;
}

:deep(.el-upload) {
  display: flex;
  gap: 20px;
  width: 100% !important;
}
@import "@/assets/css/mixins.scss";

.el-dialog-div {
  @include thin-scrollbar(8px, #888);
  max-height: 60vh;
  /* 你还可以在这个类里写其他样式 */
  background: #fff;
}

.spacer {
  display: inline-block;
  width: 120px; /* 调整宽度以满足需求 */
}

.invoice-box {
  border: 1px dashed #ccc; /* 虚线框 */
  padding: 20px 20px 0 0;
  margin-bottom: 20px;
}

:deep(.el-select) {
  width: 100%;
}

.bold-text {
  width: 100%;
  font-weight: bold;
  color: red;
  background-color: yellow;
  font-size: 16px;
}
.el-form-item__label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
}
.no-border-select :deep(.el-input__inner) {
  border: none;
  box-shadow: none;
  background: transparent; /* 背景透明，与表格融合 */
}
.no-border-select :deep(.el-textarea__inner) {
  border: none;
  box-shadow: none;
  background: transparent; /* 背景透明，与表格融合 */
}
</style>